import { render, staticRenderFns } from "./ContentsComponent.vue?vue&type=template&id=a027a51e&scoped=true"
import script from "./ContentsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentsComponent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContentsComponent.vue?vue&type=style&index=0&id=a027a51e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a027a51e",
  null
  
)

export default component.exports